<template>
  <div>
    <b-card>
      <AgGrid
        ref="UserListGrid"
        :grid="aggrid"
        @LoadAll="LoadAll"
      >
        <template v-slot:lftbtn>
          <b-button
            v-b-tooltip.hover="'Create a New User'"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mb-1"
            @click="CreateNewUser()"
          ><feather-icon
             icon="PlusIcon"
             class="mr-50"
           />
            <span class="align-middle">New User</span></b-button>
        </template>

      </AgGrid>
    </b-card>

    <b-modal
      id="CreateUserModal"
      ref="CreateUser"
      title="New User"
      size="lg"
      centered
      no-close-on-backdrop
    >
      <form-wizard
        color="#7367F0"
        :title="null"
        :subtitle="null"
        shape="square"
        finish-button-text="Save"
        back-button-text="Previous"
        class="mb-3"
        @on-complete="SaveNewUser"
      >
        <tab-content
          title="User Detail"
        >
          <validation-observer
            ref="headerRules"
            tag="form"
          >
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="User Name"
                    rules="required|max:95|email"
                  >
                    <b-form-group
                      :state="errors.length > 0 ? false:null"
                    >
                      <label class="required"><i><b>User Name:</b></i></label>
                      <b-form-input
                        id="NewUserUserName"
                        v-model="NewUser.UserName"
                        type="email"
                        :state="errors.length > 0 ? false:null"
                        placeholder="User Name"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="Password"
                    rules="required|max:45"
                  >
                    <b-form-group
                      :state="errors.length > 0 ? false:null"
                    >
                      <label class="required"><i><b>Password:</b></i></label>
                      <b-form-input
                        id="NewUserPassword"
                        v-model="NewUser.Password"
                        type="password"
                        :state="errors.length > 0 ? false:null"
                        placeholder="Password"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="Email"
                    rules=""
                  >
                    <b-form-group
                      :state="errors.length > 0 ? false:null"
                    >
                      <label><i><b>Email:</b></i></label>
                      <b-form-input
                        id="NewUserEmail"
                        v-model="NewUser.UserName"
                        type="email"
                        disabled
                        :state="errors.length > 0 ? false:null"
                        placeholder="Email"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="Role"
                    rules="required"
                  >
                    <b-form-group
                      :state="errors.length > 0 ? false:null"
                    >
                      <label class="required"><i><b>Role:</b></i></label>
                      <v-select
                        id="RoleOption"
                        v-model="NewUser.Role"
                        :options="RoleOptions"
                        label="text"
                        placeholder="Select the role"
                      />
                      <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="First Name"
                    rules="required|max:70"
                  >
                    <b-form-group
                      :state="errors.length > 0 ? false:null"
                    >
                      <label class="required"><i><b>First Name:</b></i></label>
                      <b-form-input
                        id="NewUserFirstName"
                        v-model="NewUser.FirstName"
                        :state="errors.length > 0 ? false:null"
                        placeholder="First Name"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="Last Name"
                    rules="required|max:70"
                  >
                    <b-form-group
                      :state="errors.length > 0 ? false:null"
                    >
                      <label class="required"><i><b>Last Name:</b></i></label>
                      <b-form-input
                        id="NewUserLastName"
                        v-model="NewUser.LastName"
                        :state="errors.length > 0 ? false:null"
                        placeholder="Last Name"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </validation-observer>
        </tab-content>
      </form-wizard>
      <template #modal-footer>
        <div /></template>
    </b-modal>

  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import axios from '@axios'

import { required } from '@validations'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import ViewBtnRenderer from '@core/layouts/ViewBtnRenderers/ABI/ABIAdminUserListViewBtnRenderer'
import AgGrid from '@/layouts/components/AgGrid.vue'

export default {
  components: {
    AgGrid,
    FormWizard,
    TabContent,
  },
  data() {
    return {
      required,
      aggrid: [],
      NewUser: {
        UserName: '',
        Email: '',
        Password: '',
        ClientId: '',
        FirstName: '',
        LastName: '',
        Role: '',
      },
      UserId: '',
      RoleOptions: [
        { text: 'User', value: 'user' },
        { text: 'Manager', value: 'manager' },
        { text: 'Customer', value: 'customer' },
        { text: 'Admin', value: 'company admin' },
        { text: 'Readonly Admin', value: 'readonly admin' },
        { text: 'Readonly', value: 'read' },
      ],
    }
  },
  beforeMount() {
    this.aggrid = this.InitGridInstance('UserList')
    this.aggrid.columnDefs = [
      {
        headerName: '',
        field: 'id',
        filter: false,
        sortable: false,
        autoHeight: true,
        width: 60,
        minWidth: 60,
        maxWidth: 60,
        suppressSizeToFit: true,
        suppressMovable: true,
        pinned: 'left',
        lockPinned: true,
        cellRenderer: 'ViewBtnRenderer',
        enableRowGroup: false,
        enablePivot: false,
      },
      {
        headerName: 'Status', field: 'lockoutEnd', minWidth: 100, filter: 'agSetColumnFilter', cellRenderer: params => (params.value === null ? 'Active' : 'Locked'),
      },
      { headerName: 'User Name', field: 'userName', minWidth: 100 },
      {
        headerName: 'Role', field: 'role', minWidth: 100, filter: 'agSetColumnFilter',
      },
      { headerName: 'First Name', field: 'firstName', minWidth: 100 },
      { headerName: 'Last Name', field: 'lastName', minWidth: 100 },
      { headerName: 'Email', field: 'email', minWidth: 100 },
      { headerName: 'Phone #', field: 'phoneNumber', minWidth: 100 },
      { headerName: 'Last Login', field: 'lastLoginDate', minWidth: 100 },
      { headerName: 'Created On', field: 'createDate', minWidth: 100 },
    ]
    this.aggrid.gridOptions.onSortChanged = () => { this.$refs.UserListGrid.saveState('UserList') }
    this.aggrid.gridOptions.onColumnResized = () => { this.$refs.UserListGrid.saveState('UserList') }
    this.aggrid.gridOptions.onColumnMoved = () => { this.$refs.UserListGrid.saveState('UserList') }
    this.aggrid.gridOptions.onFilterChanged = () => { this.$refs.UserListGrid.saveState('UserList') }

    this.aggrid.frameworkComponents = {
      ViewBtnRenderer,
    }
    this.LoadAll()
  },
  methods: {
    Open(id) {
      this.id = id
      this.$router.push(`/admin/userlist/detail/${id}`)
    },
    DoubleClickOpenPopup(params) {
      this.id = params.data.id
      this.$router.push(`/admin/userlist/detail/${params.data.id}`)
    },
    LoadAll() {
      Promise.all([this.LoadingStart(), this.LoadUserList()])
        .then(() => {
          this.LoadingEnd()
        })
    },
    LoadUserList() {
      axios.get(`/identity/admin/users/${this.$store.state.user.AppActiveUser.Id}/all`)
        .then(rowData => {
          this.aggrid.rowData = rowData.data
        }).then(() => {
          this.$refs.UserListGrid.ResetColumns()
        })
    },
    CreateNewUser() {
      this.$refs.CreateUser.show()
    },
    SaveNewUser() {
      this.$refs.headerRules.validate().then(result => {
        if (result) {
          this.LoadingStart()
          const UserDto = {
            UserId: this.$store.state.user.AppActiveUser.Id,
            UserPassword: this.NewUser.Password,
          }
          const IdentityModel = {
            User: {
              UserName: this.NewUser.UserName,
              Email: this.NewUser.UserName,
              EmailConfirmed: true,
              Role: this.NewUser.Role.value,
              ClientId: this.$store.state.user.AppActiveUser.ClientId,
              FirstName: this.NewUser.FirstName,
              LastName: this.NewUser.LastName,
              UserPicture: 'data:image/png;base64,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',
            },
            Roles: [
              this.NewUser.Role.value,
            ],
          }
          axios.post('/identity/admin/users', {
            UserDto,
            IdentityModel,

          })
            .then(response => {
              this.LoadingEnd()
              this.$refs.CreateUser.hide()
              this.DisplaySuccess('User data has been saved.').then(() => {
                this.$router.push(`/admin/userlist/detail/${response.data}`)
              })
            })
            .catch(e => {
              this.LoadingEnd()
              this.$refs.CreateUser.hide()
              this.DisplayError('New user cannot be saved.', `${e.response.data.errorCode} / ${e.response.data.errorMessage}`)
            })
        } else {
          this.DisplayError('New user cannot be saved', 'Please check data requirements.')
        }
      })
    },
  },
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
